import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { DirectionsModal as DirectionsModalComponent } from '../components/directions-modal';
import { BottomNav } from '../components/BottomNav';
export function DirectionsScreen() {
  const navigate = useNavigate();
  return <div className="h-screen w-full flex flex-col bg-[#0A2A4E] animate-slide-in-right" data-id="element-547">
      {/* Header with Back Button */}
      <div className="bg-[#0A2A4E] px-4 py-4 flex items-center gap-3 shadow-md" data-id="element-548">
        <button onClick={() => navigate('/home')} className="p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Go back" data-id="element-549">
          <ArrowLeftIcon className="w-6 h-6 text-white" data-id="element-550" />
        </button>
        <h1 className="text-xl font-bold text-white" data-id="element-551">Get Directions</h1>
      </div>

      {/* Map Content - Matches Modal Styling */}
      <div className="flex-1 bg-gray-50 overflow-auto" data-id="element-552">
        <div className="bg-white rounded-t-3xl shadow-2xl max-h-full overflow-auto" data-id="element-553">
          <div className="px-4 py-6" data-id="element-554">
            <DirectionsModalComponent latitude={4.73545} longitude={114.73476} locationName="Pickleball Lamunin" address="No.44, Kampong Kiudang, Tutong, Brunei" hours="8:00 AM - 2:00 AM Daily" onClose={() => navigate('/home')} data-id="lamunin-directions" />
          </div>
        </div>
      </div>

      <BottomNav data-id="element-555" />
    </div>;
}